import { MouseEvent } from 'react';

/**
 * Mirror the legacy `ui-grid-browser-tooltips` directive: on hover, set the
 * native `title` to the cell's visible `innerText` (translated enum label,
 * formatted date, etc.) rather than the raw stored value. Used only by the
 * Items and Catalog hit-list cells.
 */
export const syncHitListCellTitle = (event: MouseEvent<HTMLElement>) => {
    const text = event.currentTarget.innerText.trim();
    if (text) {
        event.currentTarget.title = text;
    } else {
        event.currentTarget.removeAttribute('title');
    }
};
